/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Typography, Typography2 } from '@coursera/cds-core';

import HelpTipCard from 'bundles/degree-home/components/v3-dpm/HelpTipCard';
import LearnMoreDialog from 'bundles/degree-home/components/v3-dpm/components/HelpTips/LearnMoreDialog';

import _t from 'i18n!nls/degree-home';

const styles = {
  margin: () => css`
    margin-bottom: var(--cds-spacing-100);
  `,
  button: () => css`
    margin-top: auto;
    padding-top: var(--cds-spacing-100);
    padding-bottom: var(--cds-spacing-100);
  `,
};

interface HelpTipCardWithDialogProps {
  title: string;
  tip: string;
  dialogTitle: string;
  dialogMessage: React.ReactNode;
}

const HelpTipCardWithDialog = ({ title, tip, dialogTitle, dialogMessage }: HelpTipCardWithDialogProps) => {
  const [isDialogOpen, setDialogOpen] = React.useState(false);
  const openDialog = () => setDialogOpen(true);
  const closeDialog = () => setDialogOpen(false);

  return (
    <React.Fragment>
      <HelpTipCard>
        <Typography css={styles.margin} variant="h2semibold" component="h3">
          {title}
        </Typography>
        <Typography2 component="p">{tip}</Typography2>
        <Button css={styles.button} edgeAlign="start" type="button" size="medium" variant="ghost" onClick={openDialog}>
          {_t('Learn more')}
        </Button>
      </HelpTipCard>
      <LearnMoreDialog isOpen={isDialogOpen} onClose={closeDialog} title={dialogTitle} message={dialogMessage} />
    </React.Fragment>
  );
};

export default HelpTipCardWithDialog;
